import {
  format,
  getYear,
  getMonth,
  getDay,
  isSaturday,
  isAfter,
  isBefore,
  isEqual,
  addDays,
  subDays,
  endOfDay,
} from "date-fns";

export const getCalendarYearOptions = () => {
  const date = new Date().getUTCFullYear();
  let options = [];
  for (let i = date; i >= 2020; i--) {
    options.push({ value: String(i), label: String(i) });
  }
  return options;
};

export const getFinancialYearOptions = () => {
  const now = new Date();
  const year = getYear(now);
  const month = getMonth(now);

  const currentFYStartYear = month > 2 ? year : year - 1;
  let options = [];

  for (let i = currentFYStartYear; i > 2020; i--) {
    const valueFin = `${i - 1} - ${i}`;
    options.push({ value: valueFin, label: valueFin });
  }

  const fyEnd = new Date(currentFYStartYear, 2, 31, 23, 59, 59);
  if (isAfter(now, fyEnd)) {
    const nextFY = `${currentFYStartYear} - ${currentFYStartYear + 1}`;
    options.unshift({ value: nextFY, label: nextFY });
  }

  return options;
};

export const getCurrentMonthWarningText = ({
  period,
  month,
  type,
  yearType,
}) => {
  const today = new Date();
  const currentYear = format(today, "yyyy");
  const currentMonth = format(today, "MM");

  let showDate = today;
  if (isSaturday(today)) {
    showDate = subDays(today, 7);
  } else {
    const dayOfWeek = getDay(today);
    const daysSinceSaturday = (dayOfWeek + 1) % 7;
    showDate = subDays(today, daysSinceSaturday);
  }
  const lastSaturdayStr = format(showDate, "EEE, dd MMM yyyy");

  const sameOrAfter = (date, compareDate) =>
    isAfter(date, compareDate) || isEqual(date, compareDate);
  const sameOrBefore = (date, compareDate) =>
    isBefore(date, compareDate) || isEqual(date, compareDate);

  if (
    type === "Annual Report" &&
    yearType === "CALENDAR_YEAR" &&
    period &&
    period.value === currentYear
  ) {
    return `Statement reflects data as of ${lastSaturdayStr}.`;
  }

  if (
    type === "Annual Report" &&
    yearType === "FINANCIAL_YEAR" &&
    period &&
    period.value
  ) {
    const [startYear, endYear] = period.value.split(" - ").map(Number);
    if (!isNaN(startYear) && !isNaN(endYear)) {
      const fyStart = new Date(startYear, 3 - 1, 31 + 1); // Apr 1
      const fyEnd = endOfDay(new Date(endYear, 2, 31)); // Mar 31
      if (sameOrAfter(today, fyStart) && sameOrBefore(today, fyEnd)) {
        return `Statement reflects data as of ${lastSaturdayStr}.`;
      }
    }
  }

  if (
    type === "Monthly Report" &&
    period &&
    period.value === currentYear &&
    month &&
    month.value === currentMonth
  ) {
    return `Statement reflects data as of ${lastSaturdayStr}.`;
  }

  return "";
};

export const getFilteredMonthOptions = (monthOptions, period) => {
  const currentYear = getYear(new Date());
  const selectedYear = Number(period?.value);
  const currentMonth = getMonth(new Date()) + 1;
  const showFilter = period && period.value && selectedYear === currentYear;

  return monthOptions.reduce((acc, opt) => {
    if (showFilter && Number(opt.value) > currentMonth) return acc;
    acc.push({
      ...opt,
      label: `${opt.label} ${selectedYear || currentYear}`,
    });
    return acc;
  }, []);
};

export const dateFormatter = (mydate) => {
  if (!(mydate instanceof Date) || isNaN(mydate)) {
    throw new TypeError("Invalid Date object");
  }
  return format(mydate, "dd-MM-yyyy");
};

export const formatDate = (dateString, months) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const month = months[getMonth(date)];
  const day = date.getDate();
  const year = getYear(date);
  return `${month} ${day}, ${year}`;
};

export const addDaysToDate = (date, days) => {
  return addDays(date, days);
};


export function reFormatDate(inputDate) {
  const date = new Date(inputDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}-${month}-${year}`;
}

export const formatTransferDate = () => {
  const now = new Date();
  return now.toLocaleString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export const maskAccountNo = (accountNo) => {
  if (!accountNo) return "—";
  const str = String(accountNo);
  const last4 = str.slice(-4);
  return "X".repeat(9) + last4;
};

export const formatAmountWithDecimal = (val) => {
  const num = parseFloat(val);
  if (isNaN(num)) return "$ 0.00";

  return `$ ${num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};